import { render, staticRenderFns } from "./AssignmentEditModal.vue?vue&type=template&id=25852af0&"
import script from "./AssignmentEditModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports